import React from "react";

const EtransferOptions = (props) => {
  const options = [
    {
      text: 'Est-il possible de répondre à un avis de Virement Interac envoyé par message texte?',
      handler: props.actionProvider.handleEtransfer1,
      id: 1,
    },
    {
      text: 'Payer par Virement INTERAC revient-il à payer par Débit INTERAC ou à effectuer des paiements de commerce électronique par Débit Interac?',
      handler: props.actionProvider.handleEtransfer2,
      id: 2,
    },
    {
      text: 'Comment puis-je envoyer des fonds à l’aide de Virement INTERAC?',
      handler: props.actionProvider.handleEtransfer3,
      id: 3,
    },
    {
      text: 'Comment puis-je annuler une transaction effectuée par Virement Interac?',
      handler: props.actionProvider.handleEtransfer4,
      id: 4,
    },
    {
      text: 'Je dois annuler un virement, mais le destinataire a déjà accepté le dépôt. Comment puis-je annuler une transaction effectuée par Virement INTERAC?',
      handler: props.actionProvider.handleEtransfer5,
      id: 5,
    },
    {
      text: 'J’ai reçu un avis d’envoi d’argent par Virement INTERAC. Comment puis-je déposer les fonds?',
      handler: props.actionProvider.handleEtransfer6,
      id: 6,
    },
    {
      text: 'Dans quelle mesure est-il sécuritaire d’envoyer de l’argent par courriel ou par message texte à l’aide de Virement INTERAC?',
      handler: props.actionProvider.handleEtransfer7,
      id: 7,
    },
    {
      text: 'Dépôt automatique',
      handler: props.actionProvider.handleAutodeposit,
      id: 8
    },
    {
      text: 'Demande de fonds',
      handler: props.actionProvider.handleRequestMoney,
      id: 9
    },
    {
      text: 'Virement de fonds international',
      handler: props.actionProvider.handleIntlTransfersOptions,
      id: 10
    },
    {
      text: 'Sécurité',
      handler: props.actionProvider.handleetransferSecurity,
      id: 11
    },
    {
      text: 'Soutien',
      handler: props.actionProvider.handleSupport,
      id: 12
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default EtransferOptions;